import type { ReactNode } from "react";
import cx from "ui/cx";
import IconSearch from "ui/icons/IconSearchPortal";
import styles from "./EmptySearchResults.module.scss";

export interface EmptySearchResultsProps {
  className?: string;
  children?: ReactNode;
}

export default function EmptySearchResults({ className, children }: EmptySearchResultsProps) {
  return (
    <div className={cx(styles.wrapper, className)}>
      <IconSearch />
      {children ? (
        children
      ) : (
        <>
          <h3>No results found</h3>
          <p>Try another search</p>
        </>
      )}
    </div>
  );
}
